"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function cov_2jm08fyt0y() {
  var path = "/codebuild/output/src1689451169/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/resaleAvailability/lib/model.js";
  var hash = "4d1b73993be8036f87aa967dc6e029eb71b0ed7b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1689451169/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/resaleAvailability/lib/model.js",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 32
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "1": {
        start: {
          line: 3,
          column: 31
        },
        end: {
          line: 10,
          column: 5
        }
      },
      "2": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 30
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 2,
            column: 7
          },
          end: {
            line: 2,
            column: 8
          }
        },
        loc: {
          start: {
            line: 2,
            column: 15
          },
          end: {
            line: 13,
            column: 3
          }
        },
        line: 2
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4d1b73993be8036f87aa967dc6e029eb71b0ed7b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2jm08fyt0y = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2jm08fyt0y();
var ResaleAvailabilityModel = (cov_2jm08fyt0y().s[0]++, {
  get: function get(data) {
    cov_2jm08fyt0y().f[0]++;
    var resaleAvailability = (cov_2jm08fyt0y().s[1]++, {
      isDisplayResaleLink: data.displayResaleLink,
      resaleProductUrl: data.resaleProductUrl,
      resalePassUrl: data.resalePassUrl,
      resalePerformanceUrl: data.resalePerformanceUrl,
      supportedProductTypes: data.supportedProductTypes,
      supportedProductFamilySubTypes: data.supportedProductFamilySubTypes
    });
    cov_2jm08fyt0y().s[2]++;
    return resaleAvailability;
  }
});
var _default = exports.default = ResaleAvailabilityModel;